<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <div
            v-if="!businessListings || businessListings.length === 0"
            class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-info fade show mt-4 mb-1"
            role="alert"
          >
            <div class="m-alert__icon">
              <i class="flaticon-danger" />
              <span />
            </div>
            <div class="m-alert__text">
              <strong>{{ $t( 'Directory.form.Attention' ) }}:</strong> {{ $t( 'Directory.noneFound' ) }}
            </div>
          </div>

          <div
            v-if="businessListings && businessListings.length > 0"
            class="row"
          >
            <div class="col-xl-12">
              <div
                class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
                :m-portlet="'true'"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i class="flaticon-diagram m--font-brand m--icon-font-size-lg2 mt-n1" />
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ $t('menus.main.analytics') }}{{ $t('Directory.headingSuffix') }}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a
                          href="javascript:"
                          :m-portlet-tool="'fullscreen'"
                          data-trigger="hover"
                          class="m-portlet__nav-link m-portlet__nav-link--icon"
                        ><i class="la la-expand" /></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body m-form">
                  <div
                    id="search"
                    class=""
                  >
                    <div id="metrics">
                      <form
                        id="filterForm"
                        class="m-form--label-align-left- m-form--state-"
                        @submit.prevent="startSearch()"
                      >
                        <div
                          id="DateFilter"
                          class="row"
                        >
                          <div class="col-6">
                            <div class="form-group">
                              <div class="m-form_label">
                                <label
                                  for="From"
                                  class="control-label"
                                >{{ $t('Property.Analytics.From') }}:</label>
                              </div>
                              <input
                                id="From"
                                v-model="filter.FromDate"
                                type="date"
                                min="2016-04-01"
                                class="form-control m-input  m-input--solid"
                                name="From"
                              >
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <div class="m-form_label">
                                <label
                                  for="To"
                                  class="control-label"
                                >{{ $t('Property.Analytics.To') }}:</label>
                              </div>
                              <input
                                id="To"
                                v-model="filter.ToDate"
                                type="date"
                                class="form-control m-input  m-input--solid"
                                name="To"
                              >
                            </div>
                          </div>
                          <div class="col-12">
                            <button
                              type="submit"
                              class="btn btn-brand btn-sm m-btn m-btn--custom m-btn--icon btn-block-sm mb-1"
                            >
                              <span>
                                <i class="la la-search" />
                                <span>{{ $t('common.ApplyFilters') }}</span>
                              </span>
                            </button>
                            <a
                              id="filtersBtn"
                              class="btn btn-metal btn-sm  m-btn m-btn--custom m-btn--icon btn more-options collapsed btn-block-sm mb-1"
                              role="button"
                              data-toggle="collapse"
                              href="#more-filters"
                              aria-expanded="false"
                              aria-controls="more-filters"
                            >
                              <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                              <span
                                id="moreFiltersSpan"
                                class="d-inline moreFiltersSpan"
                              >{{ $t('Property.Analytics.Morefilters') }}</span>
                            </a>
                          </div>
                        </div>
                        <div
                          id="more-filters"
                          class="row collapse pt-4"
                        >
                          <div class=" m-separator mb-3 m-separator--md" />

                          <div
                            id="viewFilter"
                            class="col-lg-12"
                          >
                            <div class="row">
                              <div class="col-12 col-sm-6">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="Id"
                                  >
                                    {{ $t('Directory.Analytics.DirectoryId') }}: <span class="m-form__help"> ({{ $t('common.multipleSelection') }})</span>
                                  </label>
                                  <div class="col-xl-12">
                                    <v-select
                                      id="Id"
                                      ref="idSelects"
                                      v-model="filter.id"
                                      :multiple="true"
                                      :searchable="true"
                                      placeholder="12345,5678,9345"
                                      :taggable="true"
                                      class="custom-select form-control m-input--solid"
                                      :select-on-key-codes="[188, 13]"
                                    >
                                      <template #no-options>
                                           &nbsp;
                                      </template>
                                    </v-select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="language"
                                  >
                                    {{ $t('Property.Analytics.language') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="language"
                                      v-model="filter.language"
                                      name="Language"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option
                                        v-for="language in languages"
                                        :key="language.code"
                                        :value="language.code"
                                      >
                                        {{ language.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="device"
                                  >
                                    {{ $t('Property.Analytics.VisitorsDevice') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="device"
                                      v-model="filter.device"
                                      name="Device"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option value="">
                                        {{ $t('Property.Analytics.Any') }}
                                      </option>
                                      <option value="mobile">
                                        {{ $t('devices.mobile') }}
                                      </option>
                                      <option value="tablet">
                                        {{ $t('devices.tablet') }}
                                      </option>
                                      <option value="desktop">
                                        {{ $t('devices.desktop') }}
                                      </option>
                                      <option value="smarttv">
                                        {{ $t('devices.smart') }}
                                      </option>
                                      <option value="n/a">
                                        {{ $t('devices.bot') }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="country"
                                  >
                                    {{ $t('Property.Analytics.VisitorsCountry') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="country"
                                      v-model="filter.country"
                                      name="Country"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option
                                        v-for="country in countries"
                                        :key="country.code"
                                        :value="country.code"
                                      >
                                        {{ country.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group">
                              <div class="mt-3">
                                <button
                                  type="submit"
                                  class="btn btn-brand btn-sm m-btn m-btn--custom m-btn--icon btn-block-sm"
                                >
                                  <span>
                                    <i class="la la-search" />
                                    <span>{{ $t('common.ApplyFilters') }}</span>
                                  </span>
                                </button>
                                <a
                                  class="btn btn-metal btn-sm  m-btn m-btn--custom m-btn--icon btn more-options collapsed"
                                  role="button"
                                  data-toggle="collapse"
                                  href="#more-filters"
                                  aria-expanded="false"
                                  aria-controls="more-filters"
                                >
                                  <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                                  <span class="d-inline">{{ $t('Property.Analytics.Hidefilters') }}</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class=" m-separator my-3 m-separator--md" />
                          </div>
                        </div>
                        <div class="row">
                          <div
                            id="metricSelection"
                            class="col-xl-8 col-lg-8 col-md-9 col-sm-9"
                          >
                            <div class="form-inline">
                              <label
                                for="metric1"
                                class="control-label mr-2"
                              >{{ $t('Property.Analytics.ViewMetric') }}:</label>
                              <select
                                id="metric1"
                                v-model="filter.Metric"
                                class="custom-select form-control m-input--solid"
                                name="Metric"
                                @change="changedMetrics"
                              >
                                <option value="view">
                                  {{ $t('homepage.stats.TotalViews') }}
                                </option>
                                <option value="incontentad">
                                  {{ $t('homepage.stats.incontentad') }}
                                </option>
                                <option value="search-views">
                                  {{ $t('homepage.stats.search-views') }}
                                </option>
                                <option value="detailed">
                                  {{ $t('homepage.stats.DetailedViews') }}
                                </option>
                                <option value="go-to-website">
                                  {{ $t('homepage.stats.WebsiteVisits') }}
                                </option>
                                <option value="enquiry">
                                  {{ $t('homepage.stats.Enquiries') }}
                                </option>
                              </select>
                              <label
                                for="metric2"
                                class="control-label mx-2"
                              >vs</label>
                              <select
                                id="metric2"
                                v-model="filter.metric2"
                                class="custom-select form-control m-input--solid"
                                name="Metric2"
                                @change="changedMetrics"
                              >
                                <option value="view">
                                  {{ $t('homepage.stats.TotalViews') }}
                                </option>
                                <option value="incontentad">
                                  {{ $t('homepage.stats.incontentad') }}
                                </option>
                                <option value="search-views">
                                  {{ $t('homepage.stats.search-views') }}
                                </option>
                                <option value="detailed">
                                  {{ $t('homepage.stats.DetailedViews') }}
                                </option>
                                <option value="go-to-website">
                                  {{ $t('homepage.stats.WebsiteVisits') }}
                                </option>
                                <option value="enquiry">
                                  {{ $t('homepage.stats.Enquiries') }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div
                            id="intervalSelection"
                            class="col-xl-4 col-lg-4 col-md-3 col-sm-3"
                            style="text-align: right;"
                          >
                            <div class="form-inline pull-right">
                              <label
                                for="interval"
                                class="control-label"
                              />
                              <select
                                id="interval"
                                v-model="filter.interval"
                                class="custom-select form-control m-input--solid"
                                name="Interval"
                                @change="changedInterval"
                              >
                                <option value="day">
                                  {{ $t('Property.Analytics.Day') }}
                                </option>
                                <option value="week">
                                  {{ $t('Property.Analytics.Week') }}
                                </option>
                                <option value="month">
                                  {{ $t('Property.Analytics.Month') }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <hr>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="panel panel-default">
                              <div class="panel-heading">
                                <h3 class="panel-title">
                                  {{ $t('Property.Analytics.Metrics') }}
                                </h3>
                              </div>
                              <div class="panel-body">
                                <div
                                  :id="'DirectoryChart'"
                                  :ref="'chart'"
                                  style="width:100%;height:400px"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <div
                          id="dimentions"
                          class="panel panel-default"
                        >
                          <div class="panel-heading">
                            <h3 class="panel-title my-5">
                              {{ $t('Property.Analytics.Dimensions') }}
                            </h3>
                          </div>
                          <div class="panel-body">
                            <div class="form-inline">
                              <label
                                for="dimention1"
                                class="control-label mr-2"
                              >{{ $t('Property.Analytics.SelectDimension') }}:</label>
                              <select
                                id="dimention1"
                                v-model="filter.dimention"
                                class="custom-select form-control m-input--solid"
                                @change="changedDimensions"
                              >
                                <option
                                  value="language"
                                  selected
                                >
                                  {{ $t('Property.Analytics.language') }}
                                </option>
                                <option value="device">
                                  {{ $t('Property.Analytics.VisitorsDevice') }}
                                </option>
                                <option value="country">
                                  {{ $t('Property.Analytics.VisitorsCountry') }}
                                </option>
                              </select>
                            </div>
                            <br>
                            <div class="table-responsive">
                              <table
                                id="tableDim"
                                class="table table-striped table-bordered with-header-border not-responsive not-collapse"
                                style="border: 2px solid #e6e7eb !important"
                              >
                                <thead>
                                  <tr>
                                    <th />
                                    <th class="noofpropertiesdoble">
                                      {{ $t('homepage.stats.TotalViews') }}
                                    </th>
                                    <th class="noofpropertiesdoble">
                                      {{ $t('homepage.stats.incontentad') }}
                                    </th>
                                    <th class="noofpropertiesdoble">
                                      {{ $t('homepage.stats.search-views') }}
                                    </th>
                                    <th class="noofpropertiesdoble">
                                      {{ $t('homepage.stats.DetailedViews') }}
                                    </th>
                                    <th class="noofpropertiesdoble">
                                      {{ $t('homepage.stats.WebsiteVisits') }}
                                    </th>
                                    <th class="noofpropertiesdoble">
                                      {{ $t('homepage.stats.Enquiries') }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-if="Object.values( dimentions || {} ).length > 0"
                                    class="font-weight-bold"
                                  >
                                    <td>{{ $t('common.total') }}</td>
                                    <td>{{ Object.values( dimentions ).reduce( ( acc, d ) => acc + toNumber( d[ 'view' ] ), 0 ) }}</td>
                                    <td>{{ Object.values( dimentions ).reduce( ( acc, d ) => acc + toNumber( d[ 'incontentad' ] ), 0 ) }}</td>
                                    <td>{{ Object.values( dimentions ).reduce( ( acc, d ) => acc + toNumber( d[ 'search-views' ] ), 0 ) }}</td>
                                    <td>{{ Object.values( dimentions ).reduce( ( acc, d ) => acc + toNumber( d[ 'detailed' ] ), 0 ) }}</td>
                                    <td>{{ Object.values( dimentions ).reduce( ( acc, d ) => acc + toNumber( d[ 'go-to-website' ] ), 0 ) }}</td>
                                    <td>{{ Object.values( dimentions ).reduce( ( acc, d ) => acc + toNumber( d[ 'enquiry' ] ), 0 ) }}</td>
                                  </tr>
                                  <tr
                                    v-for="dimention in Object.values( dimentions )"
                                    :key="dimention.description"
                                  >
                                    <td>{{ dimention.description }}</td>
                                    <td>{{ toNumber( dimention[ 'view' ] ) }}</td>
                                    <td>{{ toNumber( dimention[ 'incontentad' ] ) }}</td>
                                    <td>{{ toNumber( dimention[ 'search-views' ] ) }}</td>
                                    <td>{{ toNumber( dimention[ 'detailed' ] ) }}</td>
                                    <td>{{ toNumber( dimention[ 'go-to-website' ] ) }}</td>
                                    <td>{{ toNumber( dimention[ 'enquiry' ] ) }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->
  </div>
</template>

<script>

import AppHeader from '../../common/Header.vue';
import AppFooter from '../../common/Footer.vue';
import LeftMenu from '../../common/menus/LeftMenu.vue';

import vSelect from 'vue-select';
import { getUser, onBeforeOpenSwal } from '../../../../functions.ts';
import data from '../../../../data.js';
import locationAPI from '../../../../api-clients/location-api.js';
import { clientanalyticsapi } from '../../../../api-clients/client-analytics-api.js';
import dayjs from 'dayjs';
import { businesslistingsapi } from '../../../../api-clients/business-listings-api.js';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
        vSelect,
    },
    data() {
        return {
            filter: {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ),
                dimention: 'language',
                interval: 'day',
                Metric: 'view',
                metric2: 'detailed',
                id: [],
                device: '',
                language: '',
                country: '',
            },
            user: {},
            searchFilter: {},
            countries: [],
            languages: [],
            dimensionTable: '',
            labelsAux: [],
            labelsAuxComputed: [],
            dateText: this.$t( 'homepage.stats.Date' ),
            Metric: this.$t( 'Property.Analytics.TotalViews' ),
            metric2: this.$t( 'Property.Analytics.DetailedViews' ),
            dimentions: {},
            range: 30,
            chartData: {},
            chartOptions: {},
            businessListings: [],
        };
    },
    computed: {
        userLang() {
            return this.$i18n.locale;
        },
    },
    watch: {
        '$route.query': {
            handler: function( newquery, oldquery ) {
                if ( !this.businessListings || this.businessListings.length === 0 ) {
                    return;
                }

                // check which query param changed (newQuery vs oldQuery)
                let changedParams = [];

                let newQuery = this.getParamsFromRouteQuery( newquery );
                let oldQuery = this.getParamsFromRouteQuery( oldquery );

                // Check if each parameter in the new query has changed (or was empty or same as default)
                for ( let param in newQuery ) {
                    if ( JSON.stringify( newQuery[ param ] ) !== JSON.stringify( oldQuery[ param ] ) ) {
                        changedParams.push( param );
                    }
                }

                // Check if each parameter in the new query has changed
                for ( let param in oldQuery ) {
                    if ( JSON.stringify( oldQuery[ param ] ) !== JSON.stringify( newQuery[ param ] ) ) {
                        if ( !changedParams.includes( param ) ) {
                            changedParams.push( param );
                        }
                    }
                }

                this.updateParamsFromRoute();
                this.searchFilter = JSON.parse( JSON.stringify( this.filter ) );

                // has only dimention changed?
                let dimentionOnly = changedParams.length === 1 && ( changedParams.includes( 'dimention' ) );

                if ( dimentionOnly  ) {
                    this.queryDimensions();
                    return;
                }

                let intervalOnly = changedParams.length === 1 && changedParams.includes( 'interval' );

                if ( intervalOnly ) {
                    this.queryMetrics();
                    return;
                }

                this.queryDimensions();
                this.queryMetrics();
            },
            immediate: false,
        },
    },
    async created() {
        window.addEventListener( 'resize', this.reDrawChart );

        let byName = function( c1, c2 ) {
            var name1 = c1.name.toUpperCase();
            var name2 = c2.name.toUpperCase();
            if ( name1 < name2 ) {
                return -1;
            }
            if ( name1 > name2 ) {
                return 1;
            }
            return 0;
        };

        this.user = getUser();

        const params = new URLSearchParams();
        params.set( 'take', 50 );
        params.set( 'agents', this.user.Login );
        params.set( 'includeInactive', true );

        let result = await businesslistingsapi.get( `/listings?${params.toString()}` );

        if ( result.status !== 200 ) {
            swal( {
                title: this.$t( 'error.AnErrorOccurred' ),
                type: 'error',
                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );
        } else {
            this.businessListings = result.data.results;
        }

        let lang = this.userLang;

        let listOfCounries = data.countries().map( ( country ) => {
            return { code: country.Code,
                name: country.Labels[ lang ] };
        } ).sort( byName );
        listOfCounries.unshift( { code: '',
            name: this.$t( 'common.select' ) } );
        this.countries = listOfCounries;

        let listOfLanguages  = data.languages().map( ( language ) => {
            return { code: language.code,
                name: language.Labels[ lang ] };
        } ).sort( byName );
        listOfLanguages.unshift( { code: '',
            name: this.$t( 'common.select' ) } );
        this.languages = listOfLanguages;

        this.updateParamsFromRoute();

        this.loadExternalScripts();
        this.setUpHideShowFilters();
    },
    unmounted() {
        window.removeEventListener( 'resize', this.reDrawChart );
    },
    methods: {
        getDefaultParams() {
            return {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ),
                dimention: 'language',
                interval: 'day',
                Metric: 'view',
                metric2: 'detailed',
                id: [],
                device: '',
                language: '',
                country: '',
                Skip: 0,
            };
        },
        updateParamsFromRoute() {
            let params = this.getParamsFromRouteQuery( this.$route.query );
            this.filter = params;
        },
        getParamsFromRouteQuery( query ) {
            let params = {};

            let defaultParams = this.getDefaultParams();

            params.FromDate = query.fromdate || defaultParams.FromDate;
            params.ToDate = query.todate || defaultParams.ToDate;
            params.dimention = query.dimention || defaultParams.dimention;
            params.Metric = query.metric || defaultParams.Metric;
            params.metric2 = query.metric2 || defaultParams.metric2;
            params.interval = query.interval || defaultParams.interval;

            let ids = [];

            // convert query.types to array of ints
            if ( query.id ) {
                if ( Array.isArray( query.id ) ) {
                    ids = query.id;
                } else {
                    ids = [ query.id ];
                }
            }

            params.id = ids || defaultParams.id;
            params.device = query.device || defaultParams.device;
            params.language = query.language || defaultParams.language;
            params.country = query.country || defaultParams.country;

            return params;
        },
        updateRouteFromParams() {
            let params = this.filter;
            let defaultParams = this.getDefaultParams();

            let newRouteParams = {
                fromdate: params.FromDate,
                todate: params.ToDate,
            };

            if ( params.dimention !== defaultParams.dimention ) {
                newRouteParams.dimention = params.dimention;
            }

            if ( params.Metric !== defaultParams.Metric ) {
                newRouteParams.metric = params.Metric;
            }

            if ( params.metric2 !== defaultParams.metric2 ) {
                newRouteParams.metric2 = params.metric2;
            }

            if ( params.interval !== defaultParams.interval ) {
                newRouteParams.interval = params.interval;
            }

            if ( params.id !== defaultParams.id ) {
                newRouteParams.id = params.id;
            }

            if ( params.device !== defaultParams.device ) {
                newRouteParams.device = params.device;
            }

            if ( params.language !== defaultParams.language ) {
                newRouteParams.language = params.language;
            }

            if ( params.country !== defaultParams.country ) {
                newRouteParams.country = params.country;
            }

            if ( JSON.stringify( this.$route.query ) !== JSON.stringify( newRouteParams ) ) {
                this.$router.push( { query: newRouteParams } );
            }
        },
        reDrawChart() {
            let chartElement = document.getElementById( 'DirectoryChart' );

            if ( !chartElement ) {
                return;
            }
            if ( this.chartData && this.chartOptions ) {
                let chart = new google.visualization.AreaChart( chartElement );
                chart.draw( this.chartData, this.chartOptions );
            }
        },
        setUpHideShowFilters() {
            let vueThis = this;

            let form = document.getElementById( 'filterForm' );
            let $form = $( form );

            let moreFiltersSpans = document.querySelector( '.moreFiltersSpan' );

            $form.on( 'hide.bs.collapse', function() {
                moreFiltersSpans.innerHTML = vueThis.$t( 'Property.Analytics.MoreFilters' );
            } );
            $form.on( 'show.bs.collapse', function() {
                moreFiltersSpans.innerHTML = vueThis.$t( 'Property.Analytics.Hidefilters' );
            } );
        },
        changedMetrics() {
            this.updateRouteFromParams();
        },
        changedDimensions() {
            this.updateRouteFromParams();
        },
        changedInterval() {
            this.updateRouteFromParams();
        },
        startSearch() {
            this.updateRouteFromParams();
        },
        search() {
            if ( !this.businessListings || this.businessListings.length === 0 ) {
                return;
            }

            this.searchFilter = JSON.parse( JSON.stringify( this.filter ) );

            this.queryMetrics();
            this.queryDimensions();
        },
        async queryMetrics() {
            if ( !this.businessListings || this.businessListings.length === 0 ) {
                return;
            }

            let metricRequest = {
                Metric: this.searchFilter.Metric,
                Interval: this.searchFilter.interval,
                From: dayjs( this.searchFilter.FromDate ).tz().format(),
                To: dayjs( this.searchFilter.ToDate ).tz().add( 1, 'day' ).subtract( 1, 'millisecond' ).format(),
                Login: this.user.Login,
                Id: this.searchFilter.id,
                Device: this.searchFilter.device,
                Language: this.searchFilter.language,
                Country: this.searchFilter.country,
            };

            this.chartLoading( true );

            let queryMetric1 = clientanalyticsapi.post( '/directory/metrics', metricRequest );

            let metric2Request = JSON.parse( JSON.stringify( metricRequest ) );
            metric2Request.Metric = this.searchFilter.metric2;

            let queryMetric2 = clientanalyticsapi.post( '/directory/metrics', metric2Request );

            let resultMetric1 = await queryMetric1;
            let resultMetric2 = await queryMetric2;

            this.chartLoading( false );

            if ( resultMetric1.status !== 200 || resultMetric2.status !== 200 ) {
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.drawChart( resultMetric1.data, resultMetric2.data );
        },
        async queryDimensions() {
            if ( !this.businessListings || this.businessListings.length === 0 ) {
                return;
            }

            this.dimensionLoading( true );

            const availableMetrics = [
                'view',
                'incontentad',
                'search-views',
                'detailed',
                'go-to-website',
                'enquiry',
            ];

            try {
                const dimensionRequests = [];
                let dimensions = {};

                availableMetrics.forEach( ( metric ) => {
                    dimensions[ metric ] = {};

                    dimensionRequests.push( new Promise( async ( resolve ) => {
                        let dimentionRequest = {
                            Dimention: this.searchFilter.dimention,
                            Interval: this.searchFilter.interval,
                            From: dayjs( this.searchFilter.FromDate ).tz().format(),
                            To: dayjs( this.searchFilter.ToDate ).tz().add( 1, 'day' ).subtract( 1, 'millisecond' ).format(),
                            Login: this.user.Login,
                            Id: this.searchFilter.id,
                            Device: this.searchFilter.device,
                            Language: this.searchFilter.language,
                            Country: this.searchFilter.country,
                            Metric: metric,
                        };

                        const result = await clientanalyticsapi.post( '/directory/dimentions', dimentionRequest );

                        if ( result.status !== 200 ) {
                            swal( {
                                title: this.$t( 'error.AnErrorOccurred' ),
                                type: 'error',
                                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                                onBeforeOpen: () => {
                                    onBeforeOpenSwal();
                                },
                            } );
                            return;
                        } else {
                            dimensions[ metric ] = result.data;
                        }

                        resolve();
                    } ) );
                } );

                await Promise.allSettled( dimensionRequests );

                this.setTableData( dimensions );
            } finally {
                this.dimensionLoading( false );
            }
        },
        toNumber( value ) {
            const numeric = Number( value );
            return Number.isFinite( numeric ) ? numeric : 0;
        },
        async setTableData( dimensions ) {
            let results = {};

            Object.keys( dimensions ).forEach( ( metricName ) => {
                results[ metricName ] = {};

                const dimension = dimensions[ metricName ];

                if ( Object.keys( dimension ).length === 0 ) {
                    return;
                }

                Object.keys( dimension ).forEach( ( eventName ) => {
                    Object.keys( dimension[ eventName ].thinkspain ).forEach( ( dimensionName ) => {
                        const currentValue = results[ metricName ][ dimensionName ];

                        results[ metricName ][ dimensionName ] = this.toNumber( currentValue ) + dimension[ eventName ].thinkspain[ dimensionName ];
                    } );
                } );
            } );

            const tableData = {};

            Object.keys( results ).forEach( ( metricName ) => {
                Object.keys( results[ metricName ] ).forEach( ( dimensionName ) => {
                    const data = tableData[ dimensionName ] || {};

                    if ( !data.description ) {
                        switch ( this.searchFilter.dimention ) {
                        case 'country': {
                            let countries = this.countries;
                            let userLang = this.userLang;
                            countries.forEach( function( country, index ) {
                                if ( country.code === dimensionName ) {
                                    data.description = countries[ index ].name;
                                }
                            } );
                            break;
                        }
                        case 'language': {
                            data.description = this.$t( 'language.' + dimensionName );
                            break;
                        }
                        case 'device': {
                            data.description = this.$t( 'devices.' + dimensionName );
                            break;
                        }
                        }
                    }

                    data[ metricName ] = this.toNumber( data[ metricName ] ) + this.toNumber( results[ metricName ][ dimensionName ] );

                    tableData[ dimensionName ] = data;
                } );
            } );

            this.dimentions = tableData;
        },
        loadExternalScripts() {
            let component = this;
            let googleChartScripts = document.createElement( 'script' );
            googleChartScripts.onload = () => {
                component.externalScriptsLoaded();
            };
            googleChartScripts.setAttribute( 'src', 'https://www.gstatic.com/charts/loader.js' );
            document.head.appendChild( googleChartScripts );
        },
        externalScriptsLoaded() {
            let component = this;
            google.charts.load( 'current', { packages: [ 'corechart', 'line' ] } );
            google.charts.setOnLoadCallback( function() {
                component.search();
            } );
        },
        dimensionLoading( spin ) {
            if ( spin ) {
                mApp.block( '#dimentions', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );
            } else {
                mApp.unblock( '#dimentions' );
            }
        },
        chartLoading( spin ) {
            if ( spin ) {
                mApp.block( '#metrics', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );
            } else {
                mApp.unblock( '#metrics' );
            }
        },

        drawChart( metric1result, metric2result ) {
            let myChart = new google.visualization.DataTable();

            let title1 = this.$t( 'homepage.stats.' + this.searchFilter.Metric );
            let title2 = this.$t( 'homepage.stats.' + this.searchFilter.metric2 );

            myChart.addColumn( 'string', this.dateText );
            myChart.addColumn( 'number', title1 );
            myChart.addColumn( 'number', title2 );

            let chartElement = document.getElementById( 'DirectoryChart' );

            if ( !chartElement ) {
                return;
            }

            let metric1Max = 0;
            let metric2Max = 0;

            metric1result.forEach( ( el, index ) => {
                if ( el.Value > metric1Max ) {
                    metric1Max = el.Value;
                }

                let metric2Value = metric2result[ index ].Value;

                if ( metric2Value > metric2Max ) {
                    metric2Max = metric2Value;
                }

                myChart.addRow( [
                    dayjs( el.Time ).tz().format( 'DD MMM YYYY' ),
                    el.Value,
                    metric2Value,
                ] );
            } );

            let options = {
                enableInteractivity: true,
                colors: [ '#4382ce', '#f4516c' ],
                legend: 'top',
                width: '100%',
                title: null,
                fontSize: '12',
                italic: false,
                series: {
                    0: {
                        targetAxisIndex: 0,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false,
                        },
                        italic: false,
                    },
                    1: {
                        targetAxisIndex: 1,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false,
                        },
                        italic: false,
                    },
                },
                tooltip: {
                    trigger: 'hover',
                },
                vAxes: {
                    0: {
                        italic: false,
                        title: title1,
                        textStyle: {
                            color: '#4382ce',
                            fontSize: '12',
                            italic: false,
                        },
                        viewWindow: {
                            min: 0,
                            max: metric1Max + 2,
                        },
                    },
                    1: {
                        italic: false,
                        title: title2,
                        textStyle: {
                            color: '#f4516c',
                            fontSize: '12',
                            italic: false,
                        },
                        viewWindow: {
                            min: 0,
                            max: metric2Max + 2,
                        },
                    },
                },
                vAxis: {
                    viewWindowMode: 'explicit',
                    format: '0',
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                },
                hAxis: {
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                },
            };

            this.chartData = myChart;
            this.chartOptions = options;

            let chart = new google.visualization.AreaChart( chartElement );
            chart.draw( myChart, options );
        },
    },
};
</script>
